import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';

interface ErrorStateProps {
  title?: string;
  message?: string;
  onRetry?: () => void;
  retrying?: boolean;
  className?: string;
}

/** Shown when a data load fails — a clear message plus an optional retry. */
const ErrorState: React.FC<ErrorStateProps> = ({
  title = 'Something went wrong',
  message = 'We could not load this. Please try again.',
  onRetry,
  retrying = false,
  className = '',
}) => (
  <div role="alert" className={`flex flex-col items-center justify-center py-16 text-center ${className}`}>
    <div className="mb-4 rounded-2xl bg-red-100 p-4 dark:bg-red-900/30">
      <AlertTriangle className="h-8 w-8 text-red-500" aria-hidden="true" />
    </div>
    <h3 className="mb-1 text-lg font-semibold text-slate-800 dark:text-white">{title}</h3>
    <p className="max-w-sm text-sm text-slate-500 dark:text-slate-400">{message}</p>
    {onRetry && (
      <button
        type="button"
        onClick={onRetry}
        disabled={retrying}
        className="mt-4 inline-flex items-center gap-2 rounded-xl bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700 disabled:opacity-50"
      >
        <RefreshCw className={`h-4 w-4 ${retrying ? 'animate-spin' : ''}`} aria-hidden="true" />
        Try again
      </button>
    )}
  </div>
);

export default ErrorState;
